import React from "react";

import { LayoutGroup } from "framer-motion/dist/framer-motion";

import StyledScrollbar from "../../../../UIComponents/StyledScrollbar";
import ContentAddItem from "./ContentAddItem";
import ContentItem from "./ContentItem";
import "./builderContent.css";

import { ReactComponent as RectangleLine } from "../../../../../../assets/images/environment/RectangleLine.svg";

export default function BuilderContent(props) {
  const {
    previewTemplate, handleCreateSection, handleSectionSelect, handleSectionDelete, sections, sectionsFixed,
  } = props;

  return (
    <div className={previewTemplate ? "templateBuilderContent templateBuilderDisableSection" : "templateBuilderContent"}>
      <div className="templateBuilderContentHeader">
        <RectangleLine style={{ marginRight: "10px" }} />
        Contents
      </div>
      <div className="templateBuilderContentScrollbar">
        <StyledScrollbar>
          <div className="templateBuilderContentItems">
            <LayoutGroup>
              <ContentItem item={sectionsFixed[0]} handleSectionSelect={handleSectionSelect} />
              {sections.map((item) => (
                <ContentItem key={item.title} item={item} handleSectionSelect={handleSectionSelect} handleSectionDelete={handleSectionDelete} keyValue={item.title} />
              ))}
              <ContentAddItem handleCreateSection={handleCreateSection} />
              <ContentItem item={sectionsFixed[1]} edit={false} handleSectionSelect={handleSectionSelect} />
              {/* <ContentItem item={sectionsFixed[2]} edit={false} handleSectionSelect={handleSectionSelect} /> */}
            </LayoutGroup>
          </div>
        </StyledScrollbar>
      </div>
    </div>
  );
}
